import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed. Check your credentials.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="login-shell">
      <aside className="login-brand" aria-label="SHAHA Group">
        <div className="login-brand-mark"><span aria-hidden="true">S</span></div>
        <div className="login-brand-copy">
          <p className="login-brand-kicker">SHAHA GROUP</p>
          <h1>Operations<br />Control</h1>
          <p className="login-brand-note">Administration portal</p>
        </div>
        <span className="login-brand-index" aria-hidden="true">01 / ACCESS</span>
      </aside>

      <section className="login-panel" aria-labelledby="login-title">
        <div className="login-heading">
          <p className="login-eyebrow">ADMINISTRATOR ACCESS</p>
          <h2 id="login-title">Welcome back</h2>
          <p>Sign in with your administrator account.</p>
        </div>

        <form onSubmit={submit} className="login-form">
          <label className="login-label">
            Email address
            <input
              className="login-input"
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
            />
          </label>

          <label className="login-label">
            Password
            <input
              className="login-input"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
            />
          </label>

          {error && <div className="login-error" role="alert">{error}</div>}

          <button type="submit" className="login-submit" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="login-footnote">Protected administrator workspace</p>
      </section>
    </main>
  );
}
